/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.orderStatus.internal

import features.orderStatus.models.OrderStatusResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.orderStatus.internal.OrderStatusUseCase.Params

internal class OrderStatusUseCase : AsyncUseCase<OrderStatusResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val orderStatusService: OrderStatusService = OrderStatusServiceImpl()

    override suspend fun run(params: Params): Result<OrderStatusResponseModel> {
        return orderStatusService.getOrderStatus(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
